import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  contextualHelpIcon: {
    zIndex: 100,
  },
  contextualHelpIconTable: {
    width: '100%',
  },
  contextualHelpTooltipFlex: {
    background: '#FFF',
    border: '1px solid rgba(44, 45, 62, 0.3)',
    borderRadius: '8px',
    margin: '10px',
    width: '350px',
    position: 'absolute',
    padding: 5,
    zIndex: 2000,
    display: 'inline',
    fontFamily: 'Roboto',
  },
  closeButton: {
    float: 'right',
    display: 'inline-block',
    padding: '2px 5px',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
    fontFamily: 'monospace',
    fontSize: '17px',
  },
  contextualHelpDiv: {
    height: '0px',
    width: '0px'
  },
  contextualHelpRightTooltip: {
    top: '40px',
    left: '10px',
  },
  contextualHelpLeftTooltip: {
    left: '-345px',
    top: '40px',
  },
  animatedItem: {
    animation: `$myEffect 2s ease infinite`
  },
  "@keyframes myEffect": {
    "0%": {
      transform: "translateY(0)"
    },
    "50%":{
      transform: "translateY(-10px)"
    },
    "100%": {
      transform: "translateY(0)"
    }
  },
  title:{ 
    marginLeft: '10px', 
    textAlign: 'left',
    fontWeight: 'bold',
  },
  description:{ 
    marginLeft: '10px', 
    textAlign: 'left', 
  },
  url:{ 
    marginRight: '10px', 
    textAlign: 'right' 
  }
}));
